import React, { useState, useEffect } from "react";
import { SiG2 } from "react-icons/si";
import flowerImg from "../assets/flower.svg";
import rainbowImg from "../assets/cloudRainbow.svg";
import openMouthImg from "../assets/openMouth.svg";
import trophyImg from "../assets/trophyAward.png";
import axiosStrapiInstance from "../axiosStrapi";
import { baseUrl } from "../axiosStrapi";
import useProfile from "../customHooks/useProfile";

const MyGallery = () => {
  window.scrollTo(0, 20);
  const { userDetails } = useProfile();
  const [selectedSection, setSelectedSection] = useState("Fun & Adventure");
  const [selectedImage, setSelectedImage] = useState();
  const [tabIndex, setTabIndex] = useState(1);
  const [tabs, setTabs] = useState([]);

  function reArrangeTabs(total, item) {
    const existingCategory = total.find((obj) => obj.title === item?.category);
    if (existingCategory) {
      existingCategory.images.push(item?.image?.url);
    } else {
      total.push({
        title: item?.category,
        images: [item?.image?.url],
        backgroundColor:
          item?.category === "Fun & Adventure"
            ? "#C3DEFF"
            : item?.category === "Kids Gallery"
            ? "rgb(255,207,207)"
            : "rgb(255,249,207)",
        textColor:
          item?.category === "Fun & Adventure"
            ? "#0D4F9E"
            : item?.category === "Kids Gallery"
            ? "#D31C4F"
            : "#FDBE60",
        icon:
          item?.category === "Fun & Adventure"
            ? rainbowImg
            : item?.category === "Kids Gallery"
            ? openMouthImg
            : trophyImg,
      });
    }
    return total;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosStrapiInstance.get(
          `/api/galleries?filters[$or][0][level][$eq]=School&filters[$or][1][$and][0][level][$eq]=Class&filters[$or][1][$and][1][class][class][$eq]=${userDetails?.class?.class}&filters[$or][1][$and][2][class][section][$eq]=${userDetails?.class?.section}&sort=createdAt:asc&populate=*`
        );
        const data = response?.data?.data;
        const newData = data?.reduce(reArrangeTabs, []);
        setTabs(newData);
      } catch (error) {
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="flex sm:flex-row flex-col font-Lato sm:max-h-[calc(100vh-80px)] md:flex-row h-screen ">
      {/* Left Section */}
      <div className="sm:w-[50%] sm:h-full sm:mb-0 scrollbar-hidden  sm:overflow-y-scroll lg:w-1/3  space-y-4 p-[15px] lg:p-[30px] border-r-2">
        <h1 className="text-3xl lg:text-5xl leading-[48px] font-medium ">
          My Gallery{" "}
          <img
            src="crazyEyes.gif"
            className="inline w-[90px] h-[90px] lg:w-[112px] lg:h-[112px]"
            alt=""
          />{" "}
        </h1>
        <div className="space-y-4 mb-4">
          {tabs.map((section, index) => (
            <div
              key={section.name}
              className={`p-4 rounded-xl cursor-pointer hover:shadow-lg transition-all `}
              onClick={() => {
                setSelectedSection(section.title);
                setTabIndex(index);
              }}
              style={{
                background:
                  selectedSection !== section.title
                    ? "#E9E9E9"
                    : section.backgroundColor,
              }}
            >
              <div className="flex items-center justify-between py-[20px]">
                <h2
                  className={`text-[${section?.textColor}] w-[40%] text-3xl font-bold leading-7 `}
                  style={{
                    color:
                      selectedSection !== section.title
                        ? "#646464"
                        : section?.textColor,
                  }}
                >
                  {section.title}
                </h2>
                <img
                  src={section?.icon}
                  alt="section.title"
                  className="mr-2 w-[100px] h-[70px] text-xl"
                  style={{
                    filter:
                      selectedSection !== section.title
                        ? "grayscale(100%)"
                        : "none",
                  }}
                />
              </div>
              {selectedSection === section.title && (
                <p className=" text-base font-medium leading-6 text-[#383838]">
                  The early years of a child’s life are the most formative,
                  setting the foundation for their future success. Research
                  shows that the first five years are critical for brain
                  development, with 90% of a child’s brain growth happening
                  before they even enter kindergarten. At Mother's Pride, we
                  understand the profound impact that early education has on
                  shaping a child’s cognitive, social, and emotional
                  development. In this post, we’ll explore why investing in
                  early childhood education is one of the best decisions you can
                  make for your child’s lifelong success.
                </p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Right Section */}
      <div className="sm:w-[50%]  sm:mt-0 mt-9 lg:w-2/3 sm:py-9 px-2 sm:px-9 flex flex-col items-center">
        <div className="grid  scrollbar-hidden grid-cols-2 sm:gap-0 gap-3 sm:flex space-x-4  overflow-x-scroll min-h-[176px] overflow-y-hidden scrollbar-thin">
          {tabs[tabIndex]?.images?.map((img, index) => (
            <img
              key={index}
              src={`${baseUrl}${img}`}
              alt={`Thumbnail ${index}`}
              style={{
                marginLeft: index === 0 ? "1px" : "0px",
              }}
              className={`sm:h-[176px] h-[150px] w-[150px] sm:w-[235px] mx-auto rounded-lg object-cover cursor-pointer border-4 ${
                selectedImage === img
                  ? "border-red-500 rounded-lg"
                  : "border-transparent"
              }`}
              onClick={() => setSelectedImage(img)}
            />
          ))}
        </div>
        <div className="lg:pb-[38px] sm:block hidden max-h-[calc(100vh-(300px))] h-[100%] mt-5 w-[100%]">
          {selectedImage ? (
            <img
              src={`${baseUrl}${selectedImage}`}
              alt="Selected"
              className="lg:w-[100%] h-[100%] object-cover rounded-lg"
            />
          ) : (
            <p className="text-gray-500">Select an image to view</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyGallery;
